<template>
    <popup-wrapper
        class="popup-reward-record"
        @pop-cls="handlePopCls"
        :hasCls="true"
    >
        <h3>
            <span>{{ $t('popup.record.title') }}</span>
        </h3>
        <div class="popup-reward-list">
            <div class="popup-reward-list-head">
                <span>{{ $t('popup.record.record_time') }}</span>
                <span>{{ $t('popup.record.record_name') }}</span>
            </div>
            <div class="popup-reward-list-body" ref="scroll">
                <ul class="popup-reward-list-content">
                    <li v-for="(item, index) of rewardList" :key="index">
                        <!-- 2021.7.6 16:30 -->
                        <div class="reward-col">
                            <span>{{ rewardGetTime(item.create_time) }}</span>
                        </div>
                        <div class="reward-col reward-name">
                            <span @click="checkReward(item)">{{
                                item.item_name
                            }}</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </popup-wrapper>
</template>

<script>
import BScroll from '@better-scroll/core';
import Pullup from '@better-scroll/pull-up';
import { mapMutations, mapActions } from 'vuex';
import popupWrapper from '@/components/popup/popup-wrapper';
var dayjs = require('dayjs');
dayjs().format();

BScroll.use(Pullup);

export default {
    name: 'popup-reward-record',
    components: {
        popupWrapper
    },
    data() {
        return {
            isPullUpLoad: false,
            bscroll: null,
            rewardList: [],
            page: 1,
            size: 6
        };
    },
    computed: {
        userinfo() {
            return this.$store.state.userinfo;
        }
    },
    methods: {
        ...mapMutations([
            'HIDE_POPUP',
            'SHOW_POPUP',
            'SHOW_CODE_POPUP',
            'SET_STATE'
        ]),
        ...mapActions(['getRewardList']),
        handlePopCls() {
            this.HIDE_POPUP('rewardRecord');
        },
        initBscroll() {
            this.bscroll = new BScroll(this.$refs.scroll, {
                pullUpLoad: true,
                click: true,
                bounce: {
                    top: true,
                    left: false,
                    right: false,
                    bottom: false
                }
            });
            this.bscroll.on('pullingUp', this.pullingUpHandler);
        },
        // 奖励获取时间
        rewardGetTime(timestamp) {
            return dayjs(timestamp * 1000).format('YYYY-MM-DD HH:mm:ss');
        },
        async pullingUpHandler() {
            this.isPullUpLoad = true;
            this.page++;
            await this.getReward(this.page);
            this.bscroll.finishPullUp();
            this.isPullUpLoad = false;
        },
        async getReward(page) {
            if (this.userinfo) {
                const result = await this.getRewardList({
                    page: this.page,
                    size: this.size,
                    user_id: this.userinfo.id
                });
                if (result.code == 1) {
                    this.rewardList = [...this.rewardList, ...result.data];
                    this.bscroll.refresh();
                } else {
                    console.log(result.msg);
                }
            }
        },
        checkReward(item) {
            const type = item.type_ename;
            switch (type) {
                case 'code':
                    this.SHOW_CODE_POPUP(item);
                    break;
                case 'shop_card':
                    this.SET_STATE({
                        key: 'drawReward',
                        val: item
                    });
                    this.SHOW_POPUP('giftCard');
                    break;
                case 'kind':
                    this.SET_STATE({
                        key: 'drawReward',
                        val: item
                    });
                    this.SHOW_POPUP('entity');
            }
        }
    },
    async mounted() {
        this.initBscroll();
        await this.getReward(1);
    }
};
</script>

<style lang="less" scoped>
/deep/ .popup-wrapper {
    box-sizing: border-box;
    padding: 14px 40px 12px 36px;

    h3 {
        text-align: center;
        margin-bottom: 16px;
        span {
            font-size: 36px;
            text-align: center;
            color: #9c9273;
            position: relative;
            &::before {
                content: '';
                width: 39px;
                height: 11px;
                position: absolute;
                right: -60px;
                top: 50%;
                margin-top: -8px;
                background: url(~@/assets/img/pop_title_l.png) center/100% 100%
                    no-repeat;
            }
            &::after {
                content: '';
                width: 39px;
                height: 11px;
                position: absolute;
                left: -60px;
                top: 50%;
                margin-top: -8px;
                background: url(~@/assets/img/pop_title_r.png) center/100% 100%
                    no-repeat;
            }
        }
    }

    p {
        font-size: 24px;
        // text-align: center;
        line-height: 1.8;
        color: #474747;
    }

    .popup-reward-list {
        width: 474px;
        height: 414px;
        background: url(~@/assets/img/pop_fri_list_bg.png) center/100% 100%
            no-repeat;
        margin: 19px auto;
        padding-bottom: 10px;
        box-sizing: border-box;

        &-head {
            display: flex;
            height: 60px;
            align-items: center;

            span {
                font-size: 24px;
                line-height: 1.1;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                color: #1f3c46;
                &:nth-child(1) {
                    width: 50%;
                }
                &:nth-child(2) {
                    width: 50%;
                }
            }
        }
        &-body {
            width: 100%;
            height: 340px;
            overflow: hidden;

            li {
                display: flex;
                height: 60px;
                padding: 0 5px;
                box-sizing: border-box;
                &:nth-child(even) {
                    background-color: #f5fcfc;
                    background-clip: content-box;
                }

                .reward-col {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 50%;
                }

                span {
                    font-size: 22px;
                    line-height: 1.4;
                    // text-align: center;
                    color: #454a4c;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .reward-name {
                    span {
                        padding-bottom: 2px;
                        border-bottom: 0.5px solid #454a4c;
                    }
                }
            }
        }
    }
}
</style>
